import $ from '../$';
import each from '../functions/each';
$.fn.each = function (callback) {
    return each(this, callback);
};
